<template>
  <div class="set-end-divider flex items-center gap-3 py-3 my-1">
    <div class="set-end-line flex-1 h-px" :class="lineClass"></div>
    <span
      class="text-xs font-semibold uppercase tracking-wider whitespace-nowrap px-3"
      :class="textClass"
    >
      {{ label }}
    </span>
    <div class="set-end-line flex-1 h-px" :class="lineClass"></div>
  </div>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
  label: {
    type: String,
    default: "Set end"
  },
  theme: {
    type: String,
    default: "auto"
  }
});

const lineClass = computed(() => {
  if (props.theme === "light") return "cs-set-end-line--light";
  if (props.theme === "dark") return "cs-set-end-line--dark";
  return "cs-set-end-line--auto";
});

const textClass = computed(() => "cs-divider-text");
</script>

<style scoped>
.set-end-line {
  border-top: 1px solid;
}
</style>
